<header class="flex items-center justify-between p-4 border-top-solid54 shadow-lg bg-white" (mouseleave)="showDropdown = false">
    <div class="flex items-center">
      <img src="../../assets/SLL_Logo_S_Pink_CMYK.png" alt="Logo" class="h-8 mr-4">
      <h1 class="text-lg font-bold   italic">SchoolPulse</h1>
    </div>
    
    <div class="flex items-center space-x-4" *ngIf="isAuthenticated">
        <nav class="hidden md:flex space-x-4 text-sm">
          <a class="tour-step-1 text-gray-600 hover:text-black hover:underline underline-offset-8 font-semibold" routerLink="/dashboard" [routerLinkActive]="['text-gray-900', 'underline']">Dashboard</a>
          <a class="tour-step-8 text-gray-600 hover:text-black hover:underline underline-offset-8 font-semibold" routerLink="/annual-data" [routerLinkActive]="['text-gray-900', 'underline']">Annual Data Target</a>
          <a class="tour-step-11 text-gray-600 hover:text-black hover:underline underline-offset-8 font-semibold" routerLink="/assessment-plan" [routerLinkActive]="['text-gray-900', 'underline']">Data & Assessment Plan</a>
          <a *ngIf="enableUserMenu" class="text-gray-600 tour-step-12 hover:text-black hover:underline underline-offset-8 font-semibold" routerLink="/users" [routerLinkActive]="['underline', 'text-gray-900']">Users</a>
        </nav>
        <div class="relative tour-step-13">
          <button class="focus:outline-none" (click)="toggleDropdown()">
            <div class="h-10 w-10 flex items-center justify-center bg-black text-white rounded-full">
              <span class="text-sm font-semibold">{{userName}}</span>
            </div>
          </button>
          <div class="absolute right-0 mt-1 z-10 bg-white rounded-lg shadow-md" *ngIf="showDropdown">
            <button class="block w-full shadow-md py-1 text-left px-4 text-black hover:bg-rose-400 hover:text-white  text-sm" (click)="logout()">Logout</button>
            <button class="block w-full shadow-md py-1 text-left px-4 text-black hover:bg-rose-400 hover:text-white text-sm" (click)="startTour()">Tour</button>
          </div>
        </div>
    </div>
</header>